import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Payment from "../pages/payment/page";
import Guidelines from "../pages/guidelines/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/guidelines",
    element: <Guidelines />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
